import React, { Component } from 'react';
import Img from 'react-image'
import moment from 'moment';
import Classnames from 'classnames';
import _ from 'lodash';
import { Service } from '../../../service/service';
import { unAuthorized } from '../../../auth/Auth.ducks';
import { API } from '../../../../const';
import jwt_decode from 'jwt-decode';
import srcIconArrowPrev from '../../../../styles/img/arrow-prev.svg';
import srcIconArrowNext from '../../../../styles/img/arrow-next.svg';
import srcIconRefresh from '../../../../styles/img/icon-refresh.svg';
import srcIconEquipeGrey from '../../../../styles/img/icon-equipe-grey.svg';
import srcIconBabyGrey from '../../../../styles/img/icon-baby-grey.svg';
import srcIconKidWalkGrey from '../../../../styles/img/icon-kid-walk-grey.svg';
import srcIconEquipeOrange from '../../../../styles/img/icon-equipe-orange.svg';
import srcIconBabyOrange from '../../../../styles/img/icon-baby-orange.svg';
import srcIconKidWalkOrange from '../../../../styles/img/icon-kid-walk-orange.svg';
import srcIconEquipeBleu from '../../../../styles/img/icon-equipe-blue.svg';
import srcIconEquipeRed from '../../../../styles/img/icon-equipe-red.svg';
import srcIconEquipeYellow from '../../../../styles/img/icon-equipe-yellow.svg';
import srcIconCloseWhite from '../../../../styles/img/close-white.svg';
import srcIconAddWhite from '../../../../styles/img/add-white.svg';
import srcIconCopyWeek from '../../../../styles/img/icon-copy.svg';
import srcIconBabyBleu from '../../../../styles/img/icon-baby-blue.svg'
import ModaleEquipe from './ModaleEquipe'
import ModaleSemaine from './ModaleSemaine'
import ModaleConfirmationReset from './ModaleConfirmationReset'
import ModaleInfoStaff from './ModaleInfoStaff'
import DotLoader from "react-spinners/DotLoader";
import { css } from "@emotion/core";

import { connect } from 'react-redux'
import { getStaffing, postCopies, resetWeek } from './Staff.ducks'
import { Link } from 'react-router-dom';
import { switchFonction } from '../../../../ReactConst';

function jsUpperCaseFirst(string) {
  return _.isEmpty(string) ? string : string.charAt(0).toUpperCase();
}
function toUpperCaseFirst(string) {
  if (!_.isEmpty(string)) {
    string.toLowerCase();
    return (string.charAt(0).toUpperCase() + string.substring(1));
  }
}
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

const IconArrowPrev = () => <Img src={srcIconArrowPrev} className='img-fluid' />
const IconArrownext = () => <Img src={srcIconArrowNext} className='img-fluid' />
const IconRefresh = () => <Img src={srcIconRefresh} className='img-fluid' />
const IconEquipeGrey = () => <Img src={srcIconEquipeGrey} className='img-fluid' />
const IconBabyGrey = () => <Img src={srcIconBabyGrey} className='img-fluid' />
const IconKisWalkGrey = () => <Img src={srcIconKidWalkGrey} className='img-fluid' />
const IconEquipeOrange = () => <Img src={srcIconEquipeOrange} className='img-fluid' />
const IconEquipeRed = () => <Img src={srcIconEquipeRed} className='img-fluid' />
const IconEquipeYellow = () => <Img src={srcIconEquipeYellow} className='img-fluid' />
const IconBabyOrange = () => <Img src={srcIconBabyOrange} className='img-fluid' />
const IconKisWalkOrange = () => <Img src={srcIconKidWalkOrange} className='img-fluid' />
const IconEquipeBleu = () => <Img src={srcIconEquipeBleu} className='img-fluid' />
const IconCloseWhite = () => <Img src={srcIconCloseWhite} className='img-fluid' />
const IconAddWhite = () => <Img src={srcIconAddWhite} className='img-fluid' />
const IconCopyWeek = () => <Img src={srcIconCopyWeek} className='img-fluid' />
const IconBabyBleu = () => <Img src={srcIconBabyBleu} className='img-fluid' />

moment.locale("fr")

class Staff extends Component {
  static defaultProps = {
    staffData: {
      planningAgents: {}
    }
  };
  constructor(props) {
    super(props);
    let token = localStorage.getItem("token");
    let tokenDecoded = token ? jwt_decode(token) : "";
    this.state = {
      modaleEquipe: false,
      modaleSemaine: false,
      modaleReset: false,
      modaleInfo: false,
      year: moment().year(),
      week: moment().week(),
      currentJournee: { journeeString: null, index: 0, "planningAgents": { "matin": [], "midi": [], "apresMidi": [] }, "Marcheurs": { "matin": [], "midi": [], "apresMidi": [] }, "rampeurs": { "matin": [], "midi": [], "apresMidi": [] }, "agentsCreche": [] },
      currentDays: [],
      currentWeek: { "planningAgents": {}, "Marcheurs": {}, "rampeurs": {}, "agentsCreche": [] },
      currentPeriodAgents: [],
      currentPeriod: "",
      tokenDecoded: tokenDecoded
    }
    this.props.getStaffing(localStorage.getItem("token"), this.state.year, this.state.week)
    this.showModaleEquipe = this.showModaleEquipe.bind(this)
    this.closeModaleEquipe = this.closeModaleEquipe.bind(this)
    this.showModaleSemaine = this.showModaleSemaine.bind(this)
    this.closeModaleSemaine = this.closeModaleSemaine.bind(this)
    this.showModaleConfirmationReset = this.showModaleConfirmationReset.bind(this)
    this.closeModaleConfirmationReset = this.closeModaleConfirmationReset.bind(this)
    this.closeModaleInfo = this.closeModaleInfo.bind(this)
    this.getNextWeek = this.getNextWeek.bind(this)
    this.getPrevWeek = this.getPrevWeek.bind(this)
    this.getCurrentJournee = this.getCurrentJournee.bind(this)
    this.handleDeleteAgent = this.handleDeleteAgent.bind(this)
    this.submitModaleEquipe = this.submitModaleEquipe.bind(this)
    this.onSubmitReset = this.onSubmitReset.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (this.props.staffData !== prevProps.staffData && !_.isEmpty(this.props.staffData)) {
      let arrayOfDays = !_.isEmpty(this.props.staffData) && !_.isEmpty(this.props.staffData.planningAgents) ? Object.keys(this.props.staffData.planningAgents).sort((a, b) => moment(a).diff(b)) : []
      let journeeIndex = arrayOfDays.indexOf(moment().format("YYYY-MM-DD")) === -1 ? 0 : arrayOfDays.indexOf(moment().format("YYYY-MM-DD"));
      let journeeString = arrayOfDays[journeeIndex]
      this.setState({
        currentDays: arrayOfDays,
        currentWeek: Object.assign({}, this.props.staffData),
        currentJournee: Object.assign({}, { journeeString: journeeString, index: journeeIndex, planningAgents: this.props.staffData.planningAgents[journeeString], Marcheurs: this.props.staffData.Marcheurs[journeeString], rampeurs: this.props.staffData.rampeurs[journeeString], agentsCreche: this.props.staffData.agentsCreche[journeeString] })
      })
    }
  }

  //Modal Equipe Submit Function
  submitModaleEquipe = (listAgent) => {
    let name = this.state.currentPeriod
    this.setState({
      modaleEquipe: false
    })
    const response = Service.get(`${API}api/creche/staffings/annees/${this.state.year}/semaines/${this.state.week}`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
    response.then((res) => {

      let newJournee = Object.assign({}, this.state.currentJournee, { planningAgents: Object.assign({}, res.data.planningAgents[this.state.currentJournee.journeeString], { [name]: listAgent }) })
      let newWeek = Object.assign({}, this.state.currentWeek, { planningAgents: Object.assign({}, this.state.currentWeek.planningAgents, { [this.state.currentJournee.journeeString]: Object.assign({}, this.state.currentWeek.planningAgents[this.state.currentJournee.journeeString], newJournee.planningAgents) }) })

      this.setState({
        currentPeriodAgents: listAgent, currentJournee: newJournee, currentWeek: newWeek
      })
    })
    response.catch(err => {
      if (err && err.response && err.response.status === 401) {
        this.props.unAuthorized()
      }
    })

  }

  //Modal Reset Submit
  onSubmitReset() {
    this.props.resetWeek(localStorage.getItem('token'), this.state.year, this.state.week)
    this.closeModaleConfirmationReset()
  }

  //Delete Agent
  handleDeleteAgent = (period, agent) => {
    let today = moment().format("YYYY-MM-DD")

    if (this.state.tokenDecoded.TYPE_COMPTE === "ADMIN_CRECHE" && moment(this.state.currentJournee.journeeString).isSameOrAfter(today)) {

      let periodModel = period === "matin" ? "MATIN" : period === "midi" ? "MIDI" : "APRES_MIDI"
      let data = {
        "creneau": periodModel,
        "date": this.state.currentJournee.journeeString,
        "idAgent": agent.id,
        "present": false
      }
      const response = Service.post(`${API}api/creche/staffings`, data, { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } })
      response.then((res) => {
        const getStaff = Service.get(`${API}api/creche/staffings/annees/${this.state.year}/semaines/${this.state.week}`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
        getStaff.then((res2) => {
          let listAgent = res2.data.planningAgents[this.state.currentJournee.journeeString][period]
          let newJournee = Object.assign({}, this.state.currentJournee, { planningAgents: Object.assign({}, res2.data.planningAgents[this.state.currentJournee.journeeString], { [period]: listAgent }) })
          let newWeek = Object.assign({}, this.state.currentWeek, { planningAgents: Object.assign({}, this.state.currentWeek.planningAgents, { [this.state.currentJournee.journeeString]: Object.assign({}, this.state.currentWeek.planningAgents[this.state.currentJournee.journeeString], newJournee.planningAgents) }) })

          this.setState({
            currentPeriodAgents: listAgent, currentJournee: newJournee, currentWeek: newWeek
          })
        })
        getStaff.catch(err => {
          if (err && err.response && err.response.status === 401) {
            this.props.unAuthorized()
          }
        })
      })
      response.catch(err => {
        if (err && err.response && err.response.status === 401) {
          this.props.unAuthorized()
        }
      })
    } else {
      this.setState({ modaleInfo: true })
    }

  }

  showModaleEquipe = (listAgent, period) => {
    let today = moment().format("YYYY-MM-DD")
    if (this.state.tokenDecoded.TYPE_COMPTE === "ADMIN_CRECHE" && moment(this.state.currentJournee.journeeString).isSameOrAfter(today)) {

      this.setState({ currentPeriodAgents: listAgent, currentPeriod: period, modaleEquipe: true })
    } else {
      this.setState({ modaleInfo: true })
    }
  }
  closeModaleEquipe = () => { this.setState({ modaleEquipe: false }) }

  showModaleSemaine = () => { this.setState({ modaleSemaine: true }) }
  closeModaleSemaine = () => { this.setState({ modaleSemaine: false }) }

  showModaleConfirmationReset = () => {
    if (this.state.week > moment().week()) {
      this.setState({ modaleReset: true })
    }
  }
  closeModaleConfirmationReset = () => { this.setState({ modaleReset: false }) }
  closeModaleInfo = () => { this.setState({ modaleInfo: false }) }

  //Return the current journeeafter click on the column
  getCurrentJournee(journeeString, index) {
    this.setState({
      currentJournee: Object.assign({}, { journeeString, index, planningAgents: this.state.currentWeek.planningAgents[journeeString], Marcheurs: this.state.currentWeek.Marcheurs[journeeString], rampeurs: this.state.currentWeek.rampeurs[journeeString], agentsCreche: this.state.currentWeek.agentsCreche[journeeString] })
    })
  }
  //get Next/Prev week funcitons
  getNextWeek = () => {
    let weekInYear = moment(this.state.year).weeksInYear();
    if (this.state.week + 1 < weekInYear) {

      this.props.getStaffing(localStorage.getItem("token"), this.state.year, this.state.week + 1)
      this.setState({ week: this.state.week + 1, currentDays: [], currentJournee: { journeeString: null, index: null, "planningAgents": {}, "Marcheurs": {}, "rampeurs": {} } })
    } else if (this.state.week + 1 === weekInYear) {
      this.props.getStaffing(localStorage.getItem("token"), parseInt(this.state.year) + 1, 1)
      this.setState({ week: 1, year: parseInt(this.state.year) + 1, currentDays: [], currentJournee: { journeeString: null, index: null, "planningAgents": {}, "Marcheurs": {}, "rampeurs": {} } })
    }
  }
  getPrevWeek = () => {
    let weekInYear = moment().weeksInYear();
    let weekInLastYear = moment(parseInt(this.state.year) - 1, "yyyy").weeksInYear();

    if (this.state.week - 1 > 0) {
      this.props.getStaffing(localStorage.getItem("token"), this.state.year, this.state.week - 1)
      this.setState({ week: this.state.week - 1, currentDays: [], currentJournee: { journeeString: null, index: null, "planningAgents": {}, "Marcheurs": {}, "rampeurs": {} } })
    } else if (this.state.week - 1 === 0) {
      this.props.getStaffing(localStorage.getItem("token"), this.state.year - 1, weekInLastYear)
      this.setState({ year: this.state.year - 1, week: weekInLastYear, currentDays: [], currentJournee: { journeeString: null, index: null, "planningAgents": {}, "Marcheurs": {}, "rampeurs": {} } })
    }
  }

  render() {

    return (

      <div className="main-wrapper staff" >
        <div className="banner p-0 d-flex align-items-center justify-content-center">
          <Link to="/" className="back-link" >Retour</Link>
          <div className="content">
            <h1>
              Staff
                    <br /> <small>Gestion de l’équipe et des enfants</small>
            </h1>

          </div>
        </div>
        {this.props.staffLoading ? < div className="content p-0" >
          <DotLoader
            size={100}
            color={"#ff7d26"}
            css={override}
            loading={this.props.staffLoading}
          />
        </div> :
          <div className="content-planning">
            <div className="weeks-selector">
              <div className="nav-weeks">
                <a href="#" onClick={this.getPrevWeek} className="prev-week mr-3"><IconArrowPrev /></a>
                <span className="week-nums">{!_.isEmpty(this.state.currentDays) ? moment(this.state.currentDays[0]).format("D MMMM") + " - " + moment(moment(this.state.currentDays[this.state.currentDays.length - 1])).format("D MMMM YYYY") : ""}</span>
                <a href="#" onClick={this.getNextWeek} className="next-week ml-3"><IconArrownext /></a>
              </div>
              <div className="actions">
                <a href="#" data-toggle="modal" data-target="#modalCopyWeek" onClick={(e) => this.showModaleSemaine(e)}><IconCopyWeek /></a>
                <a href="#" onClick={(e) => this.showModaleConfirmationReset(e)}><IconRefresh /></a>
              </div>
              {(this.state.modaleSemaine) ?
                <ModaleSemaine
                  closeModaleSemaine={this.closeModaleSemaine}
                  postCopies={this.props.postCopies}
                  currentYear={this.state.year}
                  currentWeek={this.state.week}
                />
                : ''}
              {(this.state.modaleEquipe) ?
                <ModaleEquipe
                  closeModaleEquipe={this.closeModaleEquipe}
                  submitModaleEquipe={this.submitModaleEquipe}
                  currentPeriodAgents={this.state.currentPeriodAgents}
                  currentPeriod={this.state.currentPeriod}
                  currentDay={this.state.currentJournee.journeeString}
                  allAgents={this.state.currentJournee.agentsCreche}
                />
                : ''}
              {(this.state.modaleReset) ?
                <ModaleConfirmationReset
                  closeModaleConfirmationReset={this.closeModaleConfirmationReset}
                  onSubmitReset={this.onSubmitReset}
                />
                : ''}
              {(this.state.modaleInfo) ?
                <ModaleInfoStaff
                  closeModaleInfo={this.closeModaleInfo}
                />
                : ''}
            </div>
            <div data-week="1" className="week-container active">
              <div className="planning-week">
                <div className="planning-entete">
                  <div className="row m-0">
                    {this.state.currentDays.map((element, index) => (

                      <div key={index} style={{ cursor: "pointer" }} onClick={() => this.getCurrentJournee(element, index)} className={`col day-${index}`}>
                        <div className="day">{moment(element).format("ddd D MMM")}</div>
                        <div className={Classnames("staffing-taux", { "bon": this.state.currentWeek.planningAgents[element].tauxStaffing === 100 }, { "extra": this.state.currentWeek.planningAgents[element].tauxStaffing > 100 }, { "mauvais": this.state.currentWeek.planningAgents[element].tauxStaffing < 100 })}>
                          {this.state.currentWeek.planningAgents[element].tauxStaffing > 100 ? "Sur-staffing " + this.state.currentWeek.planningAgents[element].tauxStaffing + "%" : "Staffing " + this.state.currentWeek.planningAgents[element].tauxStaffing + "%"}</div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="planning-days">
                  <div className="plages-horaires">
                    <div className="creneau matin">Matin</div>
                    <div className="creneau midi">Midi</div>
                    <div className="creneau apres-midi">Après-midi</div>
                  </div>
                  <div className="row m-0">
                    {this.state.currentDays.map((element, index) => (
                      <div key={index} onClick={() => this.getCurrentJournee(element, index)} className="col col-creche">
                        <div className={Classnames(`day-unit day-${index}`, { 'active': index === this.state.currentJournee.index })}>
                          <div className="plage-horaire d-flex align-items-center justify-content-center">
                            {this.state.currentWeek.planningAgents[element].tauxStaffingMatin > 100 && this.state.currentWeek.planningAgents[element].tauxStaffing !== 0 ?
                              <div class="subtotal extra"><span-pourcent>{this.state.currentWeek.planningAgents[element].tauxStaffingMatin + "%"}</span-pourcent></div>
                              : this.state.currentWeek.planningAgents[element].tauxStaffingMatin !== 100 && this.state.currentWeek.planningAgents[element].tauxStaffing !== 0 ?
                                <div class="subtotal mauvais"><span-pourcent>{this.state.currentWeek.planningAgents[element].tauxStaffingMatin + "%"}</span-pourcent></div> : ""}
                            <div className={Classnames("subtotal", { "extra": this.state.currentWeek.planningAgents[element].tauxStaffingMatin > 100 }, { "mauvais": this.state.currentWeek.planningAgents[element].manquantsMatin > 0 })}>{!_.isEmpty(this.state.currentWeek.planningAgents[element]) && this.state.currentWeek.planningAgents[element].manquantsMatin <= 0 ? <IconEquipeGrey /> : <IconEquipeRed />}<span>{_.isEmpty(this.state.currentWeek.planningAgents[element].matin) ? 0 : this.state.currentWeek.planningAgents[element].matin.length} </span></div>
                            <div className="subtotal"><IconBabyGrey /> <span>{_.isEmpty(this.state.currentWeek.rampeurs[element].matin) ? 0 : this.state.currentWeek.rampeurs[element].matin.length}</span></div>
                            <div className="subtotal"><IconKisWalkGrey /> <span>{_.isEmpty(this.state.currentWeek.Marcheurs[element].matin) ? 0 : this.state.currentWeek.Marcheurs[element].matin.length}</span></div>
                          </div>
                          <div className="plage-horaire d-flex align-items-center justify-content-center">
                            {this.state.currentWeek.planningAgents[element].tauxStaffingMidi > 100 && this.state.currentWeek.planningAgents[element].tauxStaffing !== 0 ?
                              <div class="subtotal extra"><span-pourcent>{this.state.currentWeek.planningAgents[element].tauxStaffingMidi + "%"}</span-pourcent></div>
                              : this.state.currentWeek.planningAgents[element].tauxStaffingMidi !== 100 && this.state.currentWeek.planningAgents[element].tauxStaffing !== 0 ?
                                <div class="subtotal mauvais"><span-pourcent>{this.state.currentWeek.planningAgents[element].tauxStaffingMidi + "%"}</span-pourcent></div> : ""}
                            <div className={Classnames("subtotal", { "extra": this.state.currentWeek.planningAgents[element].tauxStaffingMidi > 100 }, { "mauvais": this.state.currentWeek.planningAgents[element].manquantsMidi > 0 })}>{!_.isEmpty(this.state.currentWeek.planningAgents[element]) && this.state.currentWeek.planningAgents[element].manquantsMidi <= 0 ? <IconEquipeGrey /> : <IconEquipeRed />}<span>{_.isEmpty(this.state.currentWeek.planningAgents[element].midi) ? 0 : this.state.currentWeek.planningAgents[element].midi.length}</span></div>
                            <div className="subtotal"><IconBabyGrey /> <span>{_.isEmpty(this.state.currentWeek.rampeurs[element].midi) ? 0 : this.state.currentWeek.rampeurs[element].midi.length}</span></div>
                            <div className="subtotal"><IconKisWalkGrey /> <span>{_.isEmpty(this.state.currentWeek.Marcheurs[element].midi) ? 0 : this.state.currentWeek.Marcheurs[element].midi.length}</span></div>
                          </div>
                          <div className="plage-horaire d-flex align-items-center justify-content-center">
                            {this.state.currentWeek.planningAgents[element].tauxStaffingApresMidi > 100 && this.state.currentWeek.planningAgents[element].tauxStaffing !== 0 ?
                              <div class="subtotal extra"><span-pourcent>{this.state.currentWeek.planningAgents[element].tauxStaffingApresMidi + "%"}</span-pourcent></div>
                              : this.state.currentWeek.planningAgents[element].tauxStaffingApresMidi !== 100 && this.state.currentWeek.planningAgents[element].tauxStaffing !== 0 ?
                                <div class="subtotal mauvais"><span-pourcent>{this.state.currentWeek.planningAgents[element].tauxStaffingApresMidi + "%"}</span-pourcent></div> : ""}
                            <div className={Classnames("subtotal", { "extra": this.state.currentWeek.planningAgents[element].tauxStaffingApresMidi > 100 }, { "mauvais": this.state.currentWeek.planningAgents[element].manquantsApresMidi > 0 })}>{!_.isEmpty(this.state.currentWeek.planningAgents[element]) && this.state.currentWeek.planningAgents[element].manquantsApresMidi <= 0 ? <IconEquipeGrey /> : <IconEquipeRed />}<span>{_.isEmpty(this.state.currentWeek.planningAgents[element].apresMidi) ? 0 : this.state.currentWeek.planningAgents[element].apresMidi.length}</span></div>
                            <div className="subtotal"><IconBabyGrey /> <span>{_.isEmpty(this.state.currentWeek.rampeurs[element].apresMidi) ? 0 : this.state.currentWeek.rampeurs[element].apresMidi.length}</span></div>
                            <div className="subtotal"><IconKisWalkGrey /> <span>{_.isEmpty(this.state.currentWeek.Marcheurs[element].apresMidi) ? 0 : this.state.currentWeek.Marcheurs[element].apresMidi.length}</span></div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="row row-equipe m-0">
                <div className={Classnames(`col day-0`, { 'active': this.state.currentJournee.index === 0 })}>
                  <div className="content d-flex align-items-center justify-content-center">
                    <IconEquipeBleu /> Équipe
                        </div>
                </div>
                <div className={Classnames(`col day-1`, { 'active': this.state.currentJournee.index === 1 })}>
                  <div className="content d-flex align-items-center justify-content-center">
                    <IconEquipeBleu /> Équipe
                        </div>
                </div>
                <div className={Classnames(`col day-2`, { 'active': this.state.currentJournee.index === 2 })}>
                  <div className="content d-flex align-items-center justify-content-center">
                    <IconEquipeBleu /> Équipe
                        </div>
                </div>
                <div className={Classnames(`col day-3`, { 'active': this.state.currentJournee.index === 3 })}>
                  <div className="content d-flex align-items-center justify-content-center">
                    <IconEquipeBleu /> Équipe
                        </div>
                </div>
                <div className={Classnames(`col day-4`, { 'active': this.state.currentJournee.index === 4 })}>
                  <div className="content d-flex align-items-center justify-content-center">
                    <IconEquipeBleu /> Équipe
                        </div>
                </div>
              </div>
              <div className="planning-week planning-equipe">
                <div className="planning-days">
                  <div className="plages-horaires">
                    <div className="creneau matin">Matin</div>
                    <div className="creneau midi">Midi</div>
                    <div className="creneau apres-midi">Après-midi</div>
                  </div>
                  <div className="row m-0">
                    <div className="col">
                      <div className="plage-horaire plage-horaire-equipe">
                        {!_.isEmpty(this.state.currentJournee.planningAgents) && !_.isEmpty(this.state.currentJournee.planningAgents.matin) && this.state.currentJournee.planningAgents.matin.map((element, index) =>
                          _.isEmpty(element.prenom)&&_.isEmpty(element.nom) ? 
                          <span>Compte supprimé</span> :
                          <div key={index} className="tag-equipe">{toUpperCaseFirst(element.prenom) + " " + jsUpperCaseFirst(element.nom) + "."}<small>{"(" + switchFonction(element.fonctionAgent) + ")"}</small><span className="delete" onClick={() => this.handleDeleteAgent("matin", element)}><IconCloseWhite /></span></div>
                        )}
                        {!_.isEmpty(this.state.currentJournee.planningAgents) && Array.from(Array(this.state.currentJournee.planningAgents.manquantsMatin).keys()).map((element, index) =>
                          <div key={index} className="tag-equipe-shadow">Encadrant à staffer</div>
                        )}

                        <a style={{ cursor: "pointer" }} className="round-add-btn d-flex align-items-center justify-content-center gradient" data-toggle="modal" data-target="#modalEquipe" onClick={(e) => { if (!_.isEmpty(this.state.currentJournee.planningAgents)) { this.showModaleEquipe(this.state.currentJournee.planningAgents.matin, "matin") } }}><IconAddWhite /></a>

                      </div>

                      <div className="plage-horaire plage-horaire-equipe">
                        {!_.isEmpty(this.state.currentJournee.planningAgents) && !_.isEmpty(this.state.currentJournee.planningAgents.midi) && this.state.currentJournee.planningAgents.midi.map((element, index) =>
                          <div key={index} className="tag-equipe">{toUpperCaseFirst(element.prenom) + " " + jsUpperCaseFirst(element.nom) + "."}<small>{"(" + switchFonction(element.fonctionAgent) + ")"}</small><span className="delete" onClick={() => this.handleDeleteAgent("midi", element)}><IconCloseWhite /></span></div>
                        )}
                        {!_.isEmpty(this.state.currentJournee.planningAgents) && Array.from(Array(this.state.currentJournee.planningAgents.manquantsMidi).keys()).map((element, index) =>
                          <div key={index} className="tag-equipe-shadow">Encadrant à staffer</div>
                        )}
                        <a style={{ cursor: "pointer" }} className="round-add-btn d-flex align-items-center justify-content-center gradient" data-toggle="modal" data-target="#modalEquipe" onClick={(e) => { if (!_.isEmpty(this.state.currentJournee.planningAgents)) { this.showModaleEquipe(this.state.currentJournee.planningAgents.midi, "midi") } }}><IconAddWhite /></a>
                      </div>
                      <div className="plage-horaire plage-horaire-equipe">
                        {!_.isEmpty(this.state.currentJournee.planningAgents) && !_.isEmpty(this.state.currentJournee.planningAgents.apresMidi) && this.state.currentJournee.planningAgents.apresMidi.map((element, index) =>
                          <div key={index} className="tag-equipe">{toUpperCaseFirst(element.prenom) + " " + jsUpperCaseFirst(element.nom) + "."}<small>{"(" + switchFonction(element.fonctionAgent) + ")"}</small><span className="delete" onClick={() => this.handleDeleteAgent("apresMidi", element)}><IconCloseWhite /></span></div>
                        )}
                        {!_.isEmpty(this.state.currentJournee.planningAgents) && Array.from(Array(this.state.currentJournee.planningAgents.manquantsApresMidi).keys()).map((element, index) =>
                          <div key={index} className="tag-equipe-shadow">Encadrant à staffer</div>
                        )}
                        <a style={{ cursor: "pointer" }} className="round-add-btn d-flex align-items-center justify-content-center gradient" data-toggle="modal" data-target="#modalEquipe" onClick={(e) => { if (!_.isEmpty(this.state.currentJournee.planningAgents)) { this.showModaleEquipe(this.state.currentJournee.planningAgents.apresMidi, "apresMidi") } }}><IconAddWhite /></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row row-equipe m-0">
                <div className={Classnames(`col day-0`, { 'active': this.state.currentJournee.index === 0 })}>
                  <div className="content d-flex align-items-center justify-content-center">
                    <IconBabyBleu /> Enfants
                        </div>
                </div>
                <div className={Classnames(`col day-1`, { 'active': this.state.currentJournee.index === 1 })}>
                  <div className="content d-flex align-items-center justify-content-center">
                    <IconBabyBleu /> Enfants
                        </div>
                </div>
                <div className={Classnames(`col day-2`, { 'active': this.state.currentJournee.index === 2 })}>
                  <div className="content d-flex align-items-center justify-content-center">
                    <IconBabyBleu /> Enfants
                        </div>
                </div>
                <div className={Classnames(`col day-3`, { 'active': this.state.currentJournee.index === 3 })}>
                  <div className="content d-flex align-items-center justify-content-center">
                    <IconBabyBleu /> Enfants
                        </div>
                </div>
                <div className={Classnames(`col day-4`, { 'active': this.state.currentJournee.index === 4 })}>
                  <div className="content d-flex align-items-center justify-content-center">
                    <IconBabyBleu /> Enfants
                        </div>
                </div>
              </div>
              <div className="planning-week planning-equipe">
                <div className="planning-days">
                  <div className="plages-horaires">
                    <div className="creneau matin">Matin</div>
                    <div className="creneau midi">Midi</div>
                    <div className="creneau apres-midi">Après-midi</div>
                  </div>
                  <div className="row m-0">

                    <div className="col">
                      < div className="plage-horaire plage-horaire-equipe">
                        {(!_.isEmpty(this.state.currentJournee.rampeurs.matin) && !_.isEmpty(this.state.currentJournee.Marcheurs.matin)) && this.state.currentJournee.Marcheurs.matin.concat(this.state.currentJournee.rampeurs.matin).map((element, index) => {
                          return (

                            <div key={index} className="tag-equipe">{toUpperCaseFirst(element.prenom) + " " + jsUpperCaseFirst(element.nom) + "."}</div>
                          )
                        })}
                      </div>
                      < div className="plage-horaire plage-horaire-equipe">
                        {(!_.isEmpty(this.state.currentJournee.rampeurs.midi) && !_.isEmpty(this.state.currentJournee.Marcheurs.midi)) && this.state.currentJournee.Marcheurs.midi.concat(this.state.currentJournee.rampeurs.midi).map((element, index) => {
                          return (

                            <div key={index} className="tag-equipe">{toUpperCaseFirst(element.prenom) + " " + jsUpperCaseFirst(element.nom) + "."}</div>
                          )
                        })}
                      </div>
                      < div className="plage-horaire plage-horaire-equipe">
                        {(!_.isEmpty(this.state.currentJournee.rampeurs.apresMidi) && !_.isEmpty(this.state.currentJournee.Marcheurs.apresMidi)) && this.state.currentJournee.Marcheurs.apresMidi.concat(this.state.currentJournee.rampeurs.apresMidi).map((element, index) => {
                          return (

                            <div key={index} className="tag-equipe">{toUpperCaseFirst(element.prenom) + " " + jsUpperCaseFirst(element.nom) + "."}</div>
                          )
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div >
          </div >
        }
      </div >
    );

  }
}

const mapStateToProps = (state) => ({
  staffData: state.staff.data,
  staffLoading: state.staff.loading
})

const mapDispatchToProps = {
  getStaffing,
  postCopies,
  resetWeek,
  unAuthorized
}



export default connect(mapStateToProps, mapDispatchToProps)(Staff);
